<template>
  <div>
    <section class="back-section">
      <div class="back-section__container coupon-container">
        <div class="text-right my-3">
          <ul
            class="d-flex justify-content-between align-items-center flex-wrap"
          >
            <li>
              <el-input v-model="title" placeholder="請輸入名稱"></el-input>
            </li>
            <li>
              <el-input v-model="code" placeholder="請輸入序號"></el-input>
            </li>
            <li>
              <el-input
                v-model.number="percent"
                placeholder="請輸入折扣百分比"
              ></el-input>
            </li>
            <li>
              <el-select v-model="enabled" placeholder="請選擇">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.title"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </li>
            <li>
              <div class="block">
                <el-date-picker
                  v-model="deadline_at"
                  type="date"
                  placeholder="選擇日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </div>
            </li>
            <li>
              <button class="transparent-btn mr-3" @click="addCouponHandler">
                新增優惠卷
              </button>
            </li>
          </ul>
        </div>
        <ag-grid-vue
          @grid-ready="onGridReady"
          rowSelection="multiple"
          style="height: 500px;"
          class="ag-theme-alpine"
          enableSorting="true"
          enableFilter="true"
          enableColResize="true"
          pagination="true"
          paginationAutoPageSize="true"
          groupUseEntireRow="true"
          :rowData="rowData"
          :columnDefs="columnDefs"
          :localeText="localeText"
          :gridOptions="gridOptions"
          :enterMovesDownAfterEdit="true"
        >
        </ag-grid-vue>
      </div>
    </section>
  </div>
</template>

<script>
import apiCoupon from '@/assets/js/api/back/apiCoupon';
import apiCoupons from '@/assets/js/api/back/apiCoupons';
import CouponEditButton from './components/CouponEditButton.vue';
import { mapState } from 'vuex';
export default {
  created() {
    apiCoupon.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
  },
  beforeMount() {
    // 初始化
    // 允許父通信 表格要加上:gridOptions="gridOptions"
    this.gridOptions = {
      context: {
        componentParent: this,
      },
    };
    // 中文化
    this.localeText = this.$localText;
    // 行資料
    this.createRowData();
    // 列資料
    this.createColumnDefs();
  },
  data() {
    return {
      //add coupon
      title: '',
      code: '',
      percent: '',
      enabled: '',
      deadline_at: '',
      options: [
        {
          title: '啟用',
          value: true,
        },
        {
          title: '停用',
          value: false,
        },
      ],
      //
      products: [],
      currentProductTempId: null,
      //ag
      columnDefs: '',
      rowData: '',
      gridApi: null,
      columnApi: null,
      context: null,
      gridOptions: null,
      // 默認預言設定
      localeText: {},
    };
  },
  components: { CouponEditButton },
  computed: {
    ...mapState({
      user: 'user',
    }),
    couponFormData() {
      return {
        title: this.title,
        code: this.code,
        percent: this.percent,
        enabled: this.enabled,
        deadline_at: this.deadline_at,
      };
    },
  },
  methods: {
    addCouponHandler() {
      apiCoupon.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
      apiCoupon
        .post('', this.couponFormData)
        .then(response => {
          if (response.status === 200) {
            this.$fire({
              title: `新增成功`,
              type: 'success',
              timer: 3000,
            });
            this.createRowData();
            this.title = '';
            this.code = '';
            this.percent = '';
            this.enabled = '';
            this.deadline_at = '';
          }
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
    delHandler(arr) {
      arr.forEach(({ id }) => {
        const { url: apiDel } = new this.$adminUrl(
          false,
          this.user.uuid,
          this.user.apiPath,
          id,
        );
        this.axios.delete(apiDel);
      });
    },
    //-----------------------------------------------------------以下是ag功能
    onModelUpdated(value) {
      let { data } = value;
      apiCoupon
        .patch(`/${data.id}`, {
          title: data.title,
          code: data.code,
          percent: data.percent,
          enabled: data.enabled === 'true' ? true : false,
          deadline_at: data.deadline.datetime,
        })
        .then(res => {
          if (res.status === 200) {
            this.$fire({
              title: `更新成功`,
              type: 'success',
              timer: 3000,
            });
          }
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
    onGridReady(params) {
      // 獲取aggrid.api物件才能使用裡面的方法 例如自動縮放 單元格子獲取
      this.gridApi = params.api;
      // 忘了
      this.columnApi = params.columnApi;
      // 設定自動填滿
      this.gridApi.sizeColumnsToFit();
    },
    createRowData() {
      //預設帶入 token
      apiCoupons.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
      apiCoupons.get('').then(response => {
        this.products = response.data.data;
        this.rowData = response.data.data;
      });
    },
    createColumnDefs() {
      // 表格要加上:columnDefs="columnDefs"
      this.columnDefs = [
        {
          headerName: '到期狀態',
          field: 'deadline.diff', // 單選
          // 寬度預設平均分配
          // width: 100,
          minWidth: 100,
          // 分左右組 left center right
          pinned: 'left',
          menuTabs: ['filterMenuTab', 'columnsMenuTab'],
        },
        {
          headerName: '到期時間',
          editable: true,
          field: 'deadline.datetime',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '標題',
          editable: true,
          field: 'title',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '折扣',
          editable: true,
          field: 'percent',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '優惠碼',
          editable: true,
          field: 'code',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '是否啟用',
          editable: true,
          field: 'enabled',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '編輯',
          field: 'edit',
          minWidth: 200,
          colId: 'cube',
          cellRendererFramework: 'CouponEditButton',
          menuTabs: ['filterMenuTab'],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>
